<template>
  <div>
    <main-header-nav :content="'修改密码'"></main-header-nav>
    <el-card style="width: 500px;margin: 30px auto;padding: 30px 10px 10px 10px;">
      <user-form
        :type="type"
        :userForm="changePasswordForm"
        :rules="rules"
      >
      </user-form>
    </el-card>
  </div>
</template>
<script>
import UserForm from './UserForm.vue'
import MainHeaderNav from '../common/MainHeaderNav'
export default {
  components: {
    UserForm, MainHeaderNav
  },
  data () {
    var self = this
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== self.changePasswordForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      type: 'changePassword',
      rules: {
        curPassword: [
          { required: true, message: '当前密码不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '新密码不能为空', trigger: 'blur' }
        ],
        checkPassword: [{ validator: validatePass, trigger: 'blur' }],
        nickName: [{ required: true, message: '昵称不能为空', trigger: 'blur' }]
      },
      changePasswordForm: {
        curPassword: '',
        password: '',
        checkPassword: ''
      }
    }
  },

  computed: {

  },

  mounted () {

  },

  methods: {

  }
}
</script>
<style></style>
